<script setup>
import {reactive, onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  search: null,
  dataLoading: true,
  headers: [
    { title: 'Client', key: 'client' },
    { title: '#Claims Past 30 Days', key: 'claims' },
    { title: 'Sum Invoices Past 30 Days', key: 'suminvoices' },
    { title: 'Avg Cycle Time Past 30 Days', key: 'cycle' },
  ],
  items: [],
});

onMounted(()=>{
  ApiWrapper.get('client-revenue', 'client-revenue')
      .then((response) => {
        if(response.revenue){
          data.items = response.revenue;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false;
      })
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Client Revenue</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.suminvoices`]="{ item }">
          <span>{{ item.suminvoicesFormatted }}</span>
        </template>

        <template v-slot:[`item.client`]="{ item }">
          <RouterLink :to="`/client/${item.id}`">
            {{ item.client }}
          </RouterLink>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>